import { generatedBlogPosts } from "./generated-blog";

export const blogPosts = generatedBlogPosts;

export function getBlogPost(slug: string) {
  return blogPosts.find((post) => post.slug === slug);
}
